import React from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignStatus } from '@dev/ee-api/ee-api-models';
import { StatusBadge } from '@/assets/StatusBadge';
import { StatusBadgeProps } from '../../CampaignsListInterface';

export const StatusBadgeComponent = (props: StatusBadgeProps): JSX.Element => {
    const { t } = useTranslation();
    const { index, status } = props;
    const value = status === CampaignStatus.Active ? t('scheduled') : status;

    return <StatusBadge key={`status-${index}`} value={value} status={status} />;
};
